import { InfoIcon, Text } from '@viapeople/components'

interface ResultsAccessDeniedProps {
	moduleName: string
}

export function ResultsAccessDenied({ moduleName }: ResultsAccessDeniedProps) {
	return (
		<div className='px-6 mt-6'>
			<div className='max-w-2xl mx-auto bg-warning-100 border border-warning-300 rounded-lg px-4 py-4'>
				<div className='flex items-start gap-3'>
					<InfoIcon className='text-orange-600 mt-0.5 flex-shrink-0' size={20} />
					<div>
						<Text variant='medium' weight='semibold' className='text-gray-900 mb-2'>
							Results Access Restricted
						</Text>
						<Text variant='small' className='text-gray-700 mb-2'>
							Results are only accessible to {moduleName} Viewer Admins.
						</Text>
						<Text variant='small' className='text-gray-600'>
							Contact your organization administrator to request Viewer Admin access.
						</Text>
					</div>
				</div>
			</div>
		</div>
	)
}
